class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.setHeaderCartIconAccessibility();
    
    document.addEventListener('DOMContentLoaded', () => {
       this.checkAndOpenPersistent();
    });
  }

  checkAndOpenPersistent() {
    // [UPDATE] Nâng giới hạn lên 1300px
    if (window.innerWidth < 1300 || window.location.pathname.includes('/cart')) return;

    const count = parseInt(this.getAttribute('data-count') || 0);
    if (count > 0) {
        this.open(null, false); 
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    
    cartLink.setAttribute('role', 'button');
    
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      window.location.href = '/cart';
    });
  }

  open(triggeredBy, animate = true) {
    // [UPDATE] Nâng giới hạn lên 1300px
    if (window.innerWidth < 1300) return;

    if (triggeredBy) this.setActiveElement(triggeredBy);
    
    document.body.classList.add('drawer-open-body');
    
    this.classList.add('active');
    if (animate) {
        this.classList.add('animate');
    }
  }

  close() {
    const count = parseInt(this.getAttribute('data-count') || 0);
    // [UPDATE] Nâng giới hạn lên 1300px
    if (count > 0 && window.innerWidth >= 1300) return;

    this.classList.remove('active');
    document.body.classList.remove('drawer-open-body');
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = document.getElementById(section.id);
      if (sectionElement) sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id]);
    });

    const isEmpty = this.querySelector('.drawer__inner').classList.contains('is-empty');
    this.setAttribute('data-count', isEmpty ? 0 : 1);

    setTimeout(() => {
       if (isEmpty) {
           this.classList.remove('active');
           document.body.classList.remove('drawer-open-body');
       } else {
           if (window.innerWidth >= 1300) this.open(null, true);
       }
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      { id: 'cart-drawer', selector: '#CartDrawer' },
      { id: 'cart-icon-bubble' }
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }
    ];
  }
}
customElements.define('cart-drawer-items', CartDrawerItems);